import { createContext } from 'react'

export type ABExperiments = { [key: string]: boolean }

export const ABExperimentsContext = createContext<ABExperiments | null>(null)

export const ABExperimentsProvider = ABExperimentsContext.Provider
